const tableHeaders = [
  {
    label: 'user',
    key: 'userId',
    sortable: false,
  },
  {
    label: 'first',
    key: 'firstName',
    sortable: false,
  },
  {
    label: 'last',
    key: 'lastName',
    sortable: false,
  },
  {
    label: 'program',
    key: 'domain',
    sortable: false,
  },
  {
    label: 'dealer-name',
    key: 'dealerName',
    sortable: false,
  },
  {
    label: 'dealer-code',
    key: 'entity',
    sortable: false,
  },
  {
    label: 'BC',
    key: 'businessCenter',
    sortable: false,
  },
  {
    label: 'role',
    key: 'description',
    sortable: false,
  },
  {
    label: 'service-district',
    key: 'serviceDistrict',
    sortable: false,
  },
  {
    label: 'sales-district',
    key: 'salesDistrict',
    sortable: false,
  },
];

export default () => tableHeaders;
